// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__zRx0H","default":"Banner_default__GSTlx","error":"Banner_error__x3jqv","warning":"Banner_warning__jN16w"};